import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25 2H3a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9v2h-2v2h8v-2h-2v-2h9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 14H3V4h22z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 12.8 6.4 10 9 7.2 7.8 6 4 10l3.8 4zm10-5.6 2.6 2.8-2.6 2.8 1.2 1.2 3.8-4-3.8-4z"
    }, null, -1)
  ]))]))
}
export default { render: render }